import {
	AI_CHAT_SEND_MESSAGE,
	AI_CHAT_SEND_MESSAGE_SUCCESS,
	AI_CHAT_SEND_MESSAGE_FAILURE,
	AI_CHAT_RESET,
	AI_CHAT_ADD_MESSAGE,
	AI_CHAT_SET_APPEAL_ID,
	AI_CHAT_HYDRATE,
} from 'constants/actions';

const emptyChatState = {
	messages: [],
	sessionId: null,
	loading: false,
	error: null,
};

const initialState = {
	currentAppealId: null,
	byAppealId: {},
};

const normalizeError = (error) => {
	if (!error) {
		return null;
	}

	if (typeof error === 'string') {
		return { type: 'crm_api', message: error };
	}

	if (typeof error === 'object') {
		const type = error.type || error.error_type || error.errorType || 'crm_api';
		const retryAfterRaw = error.retryAfterSeconds || error.retryAfter || error.retry_after;
		const retryAfterSeconds = Number.isFinite(Number(retryAfterRaw)) && Number(retryAfterRaw) > 0
			? Math.ceil(Number(retryAfterRaw))
			: null;
		const message = error.message || error.error || error.errorMessage;
		const normalized = {
			type,
			message: message || 'Unknown error',
		};

		if (retryAfterSeconds) {
			normalized.retryAfterSeconds = retryAfterSeconds;
		}

		return normalized;
	}

	return { type: 'crm_api', message: 'Unknown error' };
};

export default (state = initialState, action) => {
	switch (action.type) {
	case AI_CHAT_SEND_MESSAGE:
		if (!action.appealId) {
			return state;
		}
		return {
			...state,
			byAppealId: {
				...state.byAppealId,
				[action.appealId]: {
					...(state.byAppealId[action.appealId] || emptyChatState),
					loading: true,
					error: null,
				},
			},
		};

	case AI_CHAT_SEND_MESSAGE_SUCCESS:
		if (!action.appealId) {
			return state;
		}
		return {
			...state,
			byAppealId: {
				...state.byAppealId,
				[action.appealId]: {
					...(state.byAppealId[action.appealId] || emptyChatState),
					loading: false,
					sessionId: action.response.sessionId
						|| action.response.result?.sessionId
						|| state.byAppealId[action.appealId]?.sessionId
						|| null,
				},
			},
		};

	case AI_CHAT_SEND_MESSAGE_FAILURE:
		if (!action.appealId) {
			return state;
		}
		return {
			...state,
			byAppealId: {
				...state.byAppealId,
				[action.appealId]: {
					...(state.byAppealId[action.appealId] || emptyChatState),
					loading: false,
					error: normalizeError(action.error),
				},
			},
		};

	case AI_CHAT_ADD_MESSAGE:
		if (!action.appealId) {
			return state;
		}
		return {
			...state,
			byAppealId: {
				...state.byAppealId,
				[action.appealId]: {
					...(state.byAppealId[action.appealId] || emptyChatState),
					messages: [
						...(state.byAppealId[action.appealId]?.messages || []),
						action.message,
					],
				},
			},
		};

	case AI_CHAT_RESET:
		if (!action.appealId) {
			return {
				...initialState,
			};
		}
		return {
			...state,
			byAppealId: {
				...state.byAppealId,
				[action.appealId]: {
					...emptyChatState,
				},
			},
		};

	case AI_CHAT_SET_APPEAL_ID:
		if (state.currentAppealId === action.appealId) {
			return state;
		}
		return {
			...state,
			currentAppealId: action.appealId,
		};

	case AI_CHAT_HYDRATE:
		if (!action.appealId || !action.payload) {
			return state;
		}
		if (state.byAppealId[action.appealId]?.messages?.length) {
			return state;
		}
		return {
			...state,
			byAppealId: {
				...state.byAppealId,
				[action.appealId]: {
					...(state.byAppealId[action.appealId] || emptyChatState),
					messages: action.payload.messages || [],
					sessionId: action.payload.sessionId || null,
				},
			},
		};

	default:
		return state;
	}
};
